import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class GraphColors extends ConfigNode
  @className = 'GraphColors'

  constructor: ->
    super('graphColors')

  map: ->
    @get('value')

  update: (map, params = {}) ->
    @set('value', map, { dataType: 'json' })
    @save(params)

  reset: (params = {}) ->
    @update({}, params)

  @load: ->
    super('graphColors', @)

export default GraphColors
